import http from '@/utils/http';

export function login (data) {
  return http({
    url: '/user/login',
    method: 'post',
    data
  });
}

export function getInfo (token) {
  return http({
    url: '/user/info',
    method: 'get',
    params: { token }
  });
}

export function getAuthList (data) {
  return http({
    url: '/user/auth_list',
    method: 'post',
    data
  });
}

export function logout () {
  return http({
    url: '/user/logout',
    method: 'post'
  });
}
